import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import { searchYoutubeChannel } from '@/components/UBSafelist/api';
import { safelistKeys } from '@/utils/queryKeys';

import type { YoutubeResponseItem } from '@/components/UBSafelist/types';

export const useSearchYoutubeChannel = (
  inputValue: string,
  debounceMs = 200
) => {
  // Create a debounced version of the input value
  const [debouncedValue, setDebouncedValue] = useState(inputValue);

  // Update debounced value after delay
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(inputValue);
    }, debounceMs);

    // Clean up the timer
    return () => clearTimeout(timer);
  }, [inputValue, debounceMs]);

  return useQuery<YoutubeResponseItem[]>({
    queryKey: safelistKeys.youtubeChannelSearch(debouncedValue),
    placeholderData: keepPreviousData,
    queryFn: async () => {
      if (debouncedValue.length < 3) {
        return [];
      }

      const results = await searchYoutubeChannel(debouncedValue);

      return results.items;
    },
    // Only enable the query when we have a valid debounced value
    enabled: debouncedValue.length >= 3,
  });
};
